module.exports = __webpack_public_path__ + "distribution/img/code-kuang.6617b790.png";